import React, { useEffect, useRef } from 'react';
import {
  Route,
  Routes,
  Navigate,
  useNavigate,
  useLocation
} from 'react-router-dom';
import CheckoutCart from '../components/content/checkout/CheckoutCart';
import CheckoutWaitlist from '../components/content/checkout/CheckoutWaitlist';
import CheckoutInvite from '../components/content/checkout/CheckoutInvite';
import CheckoutExternalInvite from '../components/content/checkout/CheckoutExternalInvite';
import CheckoutInvoices from '../components/content/checkout/CheckoutInvoices';
import { useRegCartController } from '../helpers/shop/useRegCartController';
import CheckoutCompleteView from '../components/content/checkout/CheckoutCompleteView';

const CheckoutView = () => {
  const navigate = useNavigate();
  const hasFetched = useRef(false);
  const { pathname } = useLocation();
  const { fetchUserCart, checkoutPaymentParamStatus } = useRegCartController();
  const {
    urlCode,
    paymentStatus,
    showPaymentComplete,
    paymentSecureId,
    paymentSessionId
  } = checkoutPaymentParamStatus;
  const isInvoice = pathname.includes('/invoices');

  useEffect(() => {
    fetchUserCart({ includeShipping: true });
    hasFetched.current = true;
  }, []);

  useEffect(() => {
    if (!!paymentStatus && !showPaymentComplete) {
      navigate(pathname);
    }
  }, [paymentStatus]);

  return showPaymentComplete && !isInvoice ? (
    <CheckoutCompleteView
      isSuccessCode={paymentStatus === 'success'}
      secureId={paymentSecureId}
      sessionId={paymentSessionId}
    />
  ) : (
    <Routes>
      <Route
        element={<CheckoutCart hasFetched={hasFetched.current} />}
        path="/cart"
      />
      <Route element={<CheckoutWaitlist />} path="/:uuid" />
      <Route
        element={
          urlCode ? (
            <CheckoutExternalInvite inviteCode={urlCode} />
          ) : (
            <CheckoutInvite />
          )
        }
        path="/invite"
      />
      <Route element={<CheckoutInvoices />} path="/invoices/:invoiceId" />
      <Route element={<Navigate replace to="/checkout/cart" />} path="*" />
    </Routes>
  );
};

export default CheckoutView;
